import { Alert, Box, CircularProgress, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { ThousandText } from "components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectChiffreAffaireFilter } from "reducers";
import { reportingService } from "services";
import { dateFormater } from "utils/date";
import { ReportingCell } from "../common";

type ClientRow = { client: { id: number; nom: string }; previous: { montant: number; montantCumul: number }; current: { montant: number; montantCumul: number }; variation: { mois: string; cumul: string } };

export const ChiffreAffaireParClient = () => {
  const [data, setData] = useState<ClientRow[]>([]);
  const [titles, setTitles] = useState({ previous: "Exercice précédent", current: "Exercice en cours" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const filter = useSelector(selectChiffreAffaireFilter);

  useEffect(() => {
    const { type, periode } = filter;
    if (!type || !periode) return;
    const params: Record<string, any> = { type: type.value, periode: periode.value };
    if (periode.value === "mensuel") {
      params.mois = dateFormater.getMonth(filter.mois);
      params.annee = dateFormater.getYear(filter.annee);
    } else if (periode.value === "hebdo") {
      params.dateDebut = dateFormater.toBackPattern(filter.dateDebut, "yyyy-MM-dd");
      params.dateFin = dateFormater.toBackPattern(filter.dateFin, "yyyy-MM-dd");
    } else {
      params.dateDebut = dateFormater.toBackPattern(filter.date, "yyyy-MM-dd");
      params.dateFin = params.dateDebut;
    }
    let active = true;
    setLoading(true); setError("");
    reportingService.findChiffreAffaireByClients(params).then((response) => {
      if (active) { setData(response.clients || []); setTitles(response.titles || titles); }
    }).catch(() => { if (active) { setData([]); setError("Le chiffre d’affaires n’a pas pu être chargé."); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <Box sx={{ py: 8, textAlign: "center" }}><CircularProgress size={30} /></Box>;
  if (error) return <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>;
  return <TableContainer><Table sx={{ minWidth: 850 }}>
    <TableHead><TableRow><ReportingCell rowSpan={2}>Client</ReportingCell><ReportingCell align="center" colSpan={2}>{titles.previous}</ReportingCell><ReportingCell align="center" colSpan={2}>{titles.current}</ReportingCell><ReportingCell align="center" colSpan={2}>Variation</ReportingCell></TableRow>
      <TableRow><ReportingCell align="right">Période</ReportingCell><ReportingCell align="right">Cumul</ReportingCell><ReportingCell align="right">Période</ReportingCell><ReportingCell align="right">Cumul</ReportingCell><ReportingCell align="right">Période</ReportingCell><ReportingCell align="right">Cumul</ReportingCell></TableRow></TableHead>
    <TableBody>{data.length ? data.map((item) => <TableRow hover key={item.client.id}><ReportingCell><Typography variant="body2" fontWeight={600}>{item.client.nom}</Typography></ReportingCell><ReportingCell align="right"><ThousandText value={item.previous.montant} /></ReportingCell><ReportingCell align="right"><ThousandText value={item.previous.montantCumul} /></ReportingCell><ReportingCell align="right"><ThousandText value={item.current.montant} /></ReportingCell><ReportingCell align="right"><ThousandText value={item.current.montantCumul} /></ReportingCell><ReportingCell align="right">{item.variation?.mois || "—"}</ReportingCell><ReportingCell align="right">{item.variation?.cumul || "—"}</ReportingCell></TableRow>) : <TableRow><ReportingCell colSpan={7} align="center" sx={{ py: 7, color: "text.secondary" }}>Aucun chiffre d’affaires sur cette période</ReportingCell></TableRow>}</TableBody>
  </Table></TableContainer>;
};
